import React from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import StatusIndicator from '../../components/status-indicator/status-indicator.component';
import { OrderStatus } from '../../enums';
import { updateOrder } from '../../redux/thunks/orders';
import { correctURLToHttpsProtocol } from '../../utils/helpers/valid';

const OrderCard = ({ id, domain, status, backlinks, mails, createdAt }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const maxToShow = 3;

  const changeOrderStatus = (newStatus) => {
    const onSuccess = (message) => enqueueSnackbar(message, { variant: 'success' });
    const onError = (message) => enqueueSnackbar(message, { variant: 'error' });
    
    const formData = {
      orderId: id,
      status: newStatus,
    };

    dispatch(updateOrder({ formData, onSuccess, onError }));
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title
          style={{
            display: 'flex',
            gap: '0.2rem',
            alignItems: 'center',
            margin: '0',
            padding: '0',
          }}
        >
          <StatusIndicator status={status} />
          <span>
            מס' הזמנה #{id} (
            <a href={correctURLToHttpsProtocol(domain)} target="_blank">
              {domain}
            </a>
            ) (נוצר ב-{new Date(createdAt).toLocaleDateString()})
          </span>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Card.Text
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          {backlinks
            .slice(0, maxToShow)
            .map(({ _id, anchor, url, notes, categories }) => (
              <Card key={_id}>
                <p>
                  <b>קישור: </b>
                  <a href={correctURLToHttpsProtocol(url)} target="_blank">
                    {anchor}
                  </a>
                </p>
                {notes && notes.length > 0 && (
                  <p>
                    <b>הערות: </b>
                    {notes}
                  </p>
                )}
                <p>
                  <b>קטגוריות: </b>
                  {categories.map(({ name }) => name).join(', ')}
                </p>
              </Card>
            ))}
          {backlinks.length > maxToShow && <p>...</p>}
          {mails.length > 0 && (
            <p>
              <b>מיילים: </b>
              {mails.join(', ')}
            </p>
          )}
        </Card.Text>
        <Card.Text
          style={{
            display: 'flex',
            gap: '0.5rem',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: '0.5rem',
            }}
          >
            {backlinks.length > maxToShow && <NavLink to={`/orders/${id}`}><Button variant="primary">עוד</Button></NavLink>}
            {status === OrderStatus.pending && <Button variant='primary' onClick={() => changeOrderStatus(OrderStatus.completed)}>סמן כהושלם</Button>}
          </div>
          {status !== OrderStatus.canceled &&
            status !== OrderStatus.completed && (
              <Button variant="danger" onClick={() => changeOrderStatus(OrderStatus.canceled)}>בטל</Button>
            )}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default OrderCard;
